module.exports = __webpack_public_path__ + "img/photo-studio-razor-30.56c3d312.png";